module.exports = __webpack_public_path__ + "img/align_button.807d410a.svg";